<div class="rs-panel-big rs-bg-c2">
  <ng-container *ngFor="let aProductSplit of productSplit">
    <my-bill-odb-category-details
      *ngIf="aProductSplit?.categoryDetails"
      [categoryDetails]="aProductSplit.categoryDetails"
      [billingAccountNumber]="billingAccountNumber"
      [documentReference]="documentReference"
      category="subscription"
    ></my-bill-odb-category-details>
  </ng-container>
</div>
<div
  class="panel rs-bg-primary rs-margin-bottom2-s rs-margin-bottom4-m"
  my-bill-odb-total
  [amount]="totalAmount"
></div>
